import React from "react"
import {Box} from "@mui/system"
import {Grid, Typography} from "@mui/material"
import PropTypes from "prop-types"
import theme from "../../../../theme/theme"
import SummarySkeletonGrid from "../summary-skeleton/summary-skeleton"

const InfoItem = ({label, value}) => {
    return (
        <Box sx={{display: "flex", flexDirection: "column", gap: "5px"}}>
            <Typography
                variant="contraHeading"
                sx={{color: theme.palette.primary.white70}}
            >
                {label}
            </Typography>
            <Typography variant="textBody" color="common.white">
                {value}
            </Typography>
        </Box>
    )
}

InfoItem.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

const FREQUENCIA_RECOMPRA_LABELS = {
    1: "Mensal",
    2: "Bimestral",
    3: "Trimestral",
    4: "Quadrimestral",
    5: "Semestral",
    6: "Anual",
    7: "Indeterminado",
    8: "Não tem",
}

export const BoxDataEventFlow = ({parametersData, loading}) => {
    const fieldsParametrers = [
        {label: "Ínicio Rentabilidade", key: "DataRentabilidadeInicio", type: "date"},
        {label: "Fim Rentabilidade", key: "DataRentabilidadeFim", type: "date"},
        {label: "Valor Nominal", key: "ValorNominal", type: "number"},
        {label: "Defasagem", key: "Defasagem", type: "number"},
        {label: "Mês Aniversário", key: "MesAniversarioAnualSemestral", type: "text"},
        {label: "Projeção Inflação", key: "ProjecaoInflacao", type: "text"},
        {label: "Inflação Negativa", key: "InflacaoNegativa", type: "text"},
        {label: "Periodicidade Atualização Monetária", key: "PeriodicidadeAtualizacaoMonetaria", type: "text"},
        {label: "Juros Capitalização", key: "JurosCapitalizacao", type: "text"},
        {label: "Frequência Recompra", key: "FrequenciaRecompra", type: "frequenciaRecompra"},
    ]

    const formatDate = (date) => {
        if (!date) return "-"
        try {
            return new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(new Date(date))
        } catch {
            return "-"
        }
    }

    const formatValue = (value) => {
        if (!value) return "-"
        try {
            return new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)
        } catch {
            return "-"
        }
    }

    const formatFrequenciaRecompra = (value) => {
        if (value === null || value === undefined || value === "") return "-"
        return FREQUENCIA_RECOMPRA_LABELS[Number(value)] ?? "-"
    }

    const getValue = (field) => {
        const {key, type} = field
        const value = parametersData[key]

        if (value === "") return "-"

        if (type === "date") {
            return formatDate(value)
        }

        if (type === "number") {
            return formatValue(value)
        }

        if (type === "frequenciaRecompra") {
            return formatFrequenciaRecompra(value)
        }

        if (value === null || value === undefined) {
            return "-"
        }

        return value
    }

    return (
        <Box display="flex" gap={3} flexDirection="column">
            <Typography variant="h3" color="common.white">
                Parâmetros para Cálculo de Preços
            </Typography>

            <Box>
                <Grid container spacing={4} direction={"row"} alignItems="flex-end">
                    {fieldsParametrers.map((field, index) => (
                        <Grid key={`info-item-${index}`} item xxxs={2} md={3} lg={2.3} sm={1}>
                            {loading ?
                                <SummarySkeletonGrid /> :
                                <InfoItem
                                    label={field.label}
                                    value={getValue(field)}
                                />
                            }
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    )
}
BoxDataEventFlow.propTypes = {
    parametersData: PropTypes.object,
    loading: PropTypes.bool,
}